const tours = [
  {
    id: 1,
    name: "Tour Gran Muralla China",
    description: "Vehículo privado, cómodo de ida y vuelta desde tu hotel",
    price: "$1200 USD",
    duration: "7 días",
    includes: [
      "Visitar China sin ver la Gran Muralla es como ir a Perú y perderte Machu Picchu.",
    ],
    image:
      "https://res.cloudinary.com/ddx3pzjlm/image/upload/v1751594602/Muralla_china_acinxz.png",
    type: "Tour",
  },
  {
    id: 2,
    name: "Tour Ciudad Prohibida",
    description:
      "Explora la majestuosa Ciudad Prohibida, donde cada rincón cuenta historias de emperadores, secretos imperiales y siglos de cultura china.",
    price: "$950 USD",
    duration: "5 días",
    includes: [
      "Entre sus muros rojos, la Ciudad Prohibida oculta los misterios,el poder del antiguo imperio.",
    ],
    image:
      "https://res.cloudinary.com/ddx3pzjlm/image/upload/v1751594609/Ciudad_prohibida_tfrgec.png",
    type: "Tour",
  },
  {
    id: 3,
    name: "Tour Palacio de Verano",
    description:
      "Explora la joya imperial de Beijing, donde la historia y la naturaleza se unen en un escenario de ensueño.",
    price: "$750 USD",
    duration: "4 días",
    includes: [
      "Relájate en el jardín imperial, con paisajes mágicos donde veraneaban los emperadores.",
    ],
    image:
      "https://res.cloudinary.com/ddx3pzjlm/image/upload/v1751594605/Palacio_verano_lf7izi.png",
    type: "Tour",
  },
  {
    id: 4,
    name: "Tour Templo de Cielo",
    description:
      "Visita el Templo del Cielo, un ícono de Beijing donde historia y armonía se encuentran.",
    price: "$750 USD",
    duration: "4 días",
    includes: [
      "El testigo de los rituales donde los emperadores pedían buenas cosechas en Dinastía Ming y Qing.",
    ],
    image:
      "https://res.cloudinary.com/ddx3pzjlm/image/upload/v1751594604/Templo_cielo_wzf6sl.png",
    type: "Tour",
  },
  {
    id: 5,
    name: "Tour por otras ciudades",
    description:
      "¿Buscas nuevas aventuras? También puedo recomendarte tours increíbles en otras ciudades de China, adaptados a tus intereses y estilo de viaje.",
    price: "$750 USD",
    duration: "4 días",
    includes: [
      "Tour por Xi'an",
      "Tour por Cantón",
      "Tour por Chengdu",
      "Tour por Shanghái",
      "Tour por Guilin",
      "Tour por Zhangjiajie",
    ],
    image:
      "https://res.cloudinary.com/ddx3pzjlm/image/upload/v1751594612/Guerrero_Terracota_mxxrnt.png",
    type: "Tour",
  },
  {
    id: 6,
    name: "Servicio de Interpretación",
    description:
      "Ofrecemos servicios de interpretación en tiempo real para que puedas disfrutar de tu viaje sin barreras lingüísticas.",
    price: "$750 USD",
    duration: "4 días",
    includes: [
      "Interpretación en tiempo real.",
      "Agencia de compra, tus ojos en China.",
      "Interpretación en visita a fábricas.",
    ],
    image:
      "https://res.cloudinary.com/ddx3pzjlm/image/upload/v1751594612/Interpretacion_a1uh6i.png",
    type: "Interpretation",
  },
];

export default tours;
